module.exports = __webpack_public_path__ + "img/nodatos.125bcf49.jpg";